var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: `view-uid-${_vm.id}` } },
    [
      _c("place-picker", {
        attrs: {
          value: _vm.location,
          label: _vm.label,
          required: _vm.required,
        },
        on: {
          input: _vm.handleInput,
          placePickerStarted: function ($event) {
            return _vm.$emit("placePickerStarted")
          },
          placePickerEnded: function ($event) {
            return _vm.$emit("placePickerEnded")
          },
        },
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "locations multi-picker md-style-scoped" },
        _vm._l(_vm.value, function (location, i) {
          return _c(
            "li",
            [
              _c(
                "md-chip",
                {
                  staticClass: "md-primary",
                  attrs: { "md-deletable": "" },
                  on: {
                    "md-delete": function ($event) {
                      return _vm.remove(i)
                    },
                  },
                },
                [_vm._v(_vm._s(location.title))]
              ),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }